import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/solventfree',
    name: 'SolventFreeProducts',
    component: () => import('../views/SolventFreeProducts.vue')
  },
  {
    path:'/estersolvent',
    name: 'EsterSolventProducts',
    component: () => import('../views/EsterSolventProducts.vue')
  },
  {
    path:'/alcoholicsolvent',
    name: 'AlcoholicSolventProducts',
    component: () => import('../views/AlcoholicSolventProducts.vue')
  },
  {
    path: '/materials',
    name: 'Materials',
    component: () => import('../views/Materials.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/Support.vue')
  },
  {
    path: '/hr',
    name: 'HR',
    component: () => import('../views/HR.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/language-selection',
    name: 'LanguageSelection',
    component: () => import('../views/LanguageSelection.vue')
  },

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router